import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import CobaltMappingForm from './CobaltMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function CobaltCredentialForm(props, ref) {
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
        },
    {
        name: "apiToken",
        label: "API Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CobaltMappingForm}
            initialValue={{ apiEndpoint: 'https://api.cobalt.io' }}
        />
    )
}

export default forwardRef(CobaltCredentialForm);